import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFetchPartnerUserKeysError extends BaseEitherError {}

export type TKeysManagerFetchPartnerUserKeysOperationErrors = KeysManagerFetchPartnerUserKeysError;
